<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="flex flex_gap">
          <DateSelect ref="date"/>
          <LoadingButton
            title="Показать отчет"
            type="button"
            :loading="loading"
            :color="$constants.SUCCESS_COLOR"
            :onClick="() => showReport()"
            className="btn btn-outline-success"
          />
        </div>
      </div>
    </div>
    <template v-if="loading || records">
      <div class="card">
        <div class="card-header">
          <h6>Балансы счетов</h6>
        </div>
        <div class="card-body">
          <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
          <table class="table table-sm table-hover mt-0" v-if="records">
            <thead>
            <tr>
              <th colspan="2">Источник</th>
              <th>Ожидается перевод</th>
              <th>Баланс</th>
              <th></th>
            </tr>
            </thead>
            <tbody>
            <template v-for="(source, id) in $platformConstants.nonCashResources">
              <template v-if="source.useCards">
                <tr v-for="(card, cardId) in cards">
                  <td>{{ source.title }}</td>
                  <td>({{ card.id }}) {{ card.number }}</td>
                  <td>RUB {{
                      (Math.round((records[id]?.expect?.[cardId]?.total_price ?? 0) * 100) / 100).toLocaleString('ru-RU')
                    }} ({{ records[id]?.expect?.[cardId]?.total_orders ?? 0 }})
                  </td>
                  <td><strong>RUB {{
                      (Math.round((records[id]?.closed?.[cardId]?.total_price ?? 0) * 100) / 100).toLocaleString('ru-RU')
                    }}</strong></td>
                  <td></td>
                </tr>
              </template>
              <template v-else>
                <tr>
                  <td colspan="2">{{ source.title }}</td>
                  <td>RUB {{
                      (Math.round((records[id]?.expect?.total_price ?? 0) * 100) / 100).toLocaleString('ru-RU')
                    }}
                    ({{ records[id]?.expect?.total_orders ?? 0 }})
                  </td>
                  <td><strong>$ {{ Math.round((records[id]?.closed?.total_currency_sum ?? 0) * 100) / 100 }}</strong>
                  </td>
                  <td></td>
                </tr>
              </template>
            </template>
            </tbody>
          </table>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h6>Расходы</h6>
        </div>
        <div class="card-body">
          <p>Новый расход</p>
          <div class="form-group">
            <label>
              <input v-model="newExpenses.affect_saldo" type="checkbox"/>
              расход влияет на прибыль
            </label>
          </div>
          <div class="flex flex_gap">
            <div class="form-group">
              <label for="">Дата</label>
              <DateSelect ref="expensesDate"/>
            </div>
            <div class="form-group">
              <label for="">Источник</label>
              <select v-model="newExpenses.card_id" class="form-control">
                <option disabled value="0">Выберите карту</option>
                <option v-for="(card, cardId) in cards" :value="cardId">{{ card.number }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Сумма</label>
              <input v-model="newExpenses.sum" type="number" class="form-control">
            </div>
            <div class="form-group">
              <label for="">Комментарий</label>
              <input v-model="newExpenses.comment" type="text" class="form-control">
            </div>
            <div class="align-self-end">
              <LoadingButton
                title="Сохранить"
                type="button"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => addExpenses()"
                className="btn btn-outline-success"
              />
            </div>
          </div>
          <hr>
          <table v-if="expenses.length" class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th>карта</th>
              <th>комментарий</th>
              <th>сумма</th>
              <th></th>
            </tr>
            </thead>
            <tr v-for="(e, i) in expenses">
              <td>{{ i + 1 }} ({{ e.id }})</td>
              <td>{{ e.affect_saldo ? '' : 'Не влияет на прибыль' }}</td>
              <td>{{ cards[e.card_id]?.number ?? e.card_id }}</td>
              <td>{{ e.comment }}</td>
              <td>{{ e.sum }}</td>
              <td>
                <LoadingButton
                  title='<i class="icon-fa icon-fa-remove"/>'
                  type="button"
                  :loading="removeBtnLoading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => removeRecord()"
                  className="btn btn-default"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="card">
        <div class="card-header">
          <h6>Инкассации с обменников</h6>
        </div>
        <div class="card-body">
          <p>Новая инкассация</p>
          <div class="flex flex_gap">
            <div class="form-group">
              <label for="">Дата</label>
              <DateSelect ref="incomeDate"/>
            </div>
            <div class="form-group">
              <label for="">Источник</label>
              <select v-model="newIncome.source_id" class="form-control">
                <option disabled value="0">Выберите источник</option>
                <option v-for="(source, id) in $platformConstants.nonCashResources" v-if="!source.useCards" :value="id">
                  {{ source.title }}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label for="">Сумма</label>
              <input v-model="newIncome.sum" type="number" class="form-control">
            </div>
            <div class="form-group">
              <label for="">Кошелек получателя</label>
              <input v-model="newIncome.wallet" type="text" class="form-control">
            </div>
            <div class="align-self-end">
              <LoadingButton
                title="Сохранить"
                type="button"
                :loading="btnLoading"
                :color="$constants.SUCCESS_COLOR"
                :onClick="() => addIncome()"
                className="btn btn-outline-success"
              />
            </div>
          </div>
          <hr>
          <table v-if="withdrawal.length" class="table table-sm table-hover mt-0">
            <thead>
            <tr>
              <th></th>
              <th>Источник</th>
              <th>сумма</th>
              <th>получатель</th>
              <th></th>
            </tr>
            </thead>
            <tr v-for="(r, i) in withdrawal">
              <td>{{ i + 1 }}</td>
              <td>{{ $platformConstants.nonCashResources[r.source_id]?.title ?? r.source_id }}</td>
              <td>{{ r.sum }}</td>
              <td>{{ printSendReceive(r.data) }}</td>
              <td>
                <LoadingButton
                  title='<i class="icon-fa icon-fa-remove"/>'
                  type="button"
                  :loading="removeBtnLoading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => removeRecord()"
                  className="btn btn-default"
                />
              </td>
            </tr>
          </table>
        </div>
      </div>
    </template>

    <div class="card">
      <div class="card-header">
        <h6>История расходов по картам</h6>
      </div>
      <div class="card-body">
        <NonCashExpenses/>
      </div>
    </div>

  </div>
</template>
<script>

import DateSelect from "@/views/reports/components/DateSelect.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import NonCashExpenses from "@/views/reports/components/NonCashExpenses.vue";

export default {
  title: 'Безналичный отчет',
  components: {NonCashExpenses, LoadingButton, DateSelect},
  data() {
    return {
      loading: false,
      btnLoading: false,
      removeBtnLoading: false,
      records: null,
      cards: {},
      expenses: [],
      withdrawal: [],
      newExpenses: {
        card_id: 0,
        sum: null,
        comment: null,
        affect_saldo: 1
      },
      newIncome: {
        source_id: 0,
        sum: null,
        wallet: null,
      }
    }
  },
  methods: {
    printSendReceive(record) {
      return (record?.send_address ?? 'none').substring(0, 5) + ' -> ' + (record?.receive_address ?? 'none').substring(0, 5);
    },
    async addIncome() {
      const inc = {
        ...this.newIncome,
        date: this.$refs.incomeDate.date,
        currency_id: 34,
        data: {send_address: 'WB', receive_address: this.newIncome.wallet}
      };
      if (!+inc.source_id) {
        toastr['warning']('Выберите источник!');
        return;
      }
      if (!inc.date) {
        toastr['warning']('Выберите дату!');
        return;
      }
      if (!inc.wallet) {
        toastr['warning']('Выберите кошелек получателя!');
        return;
      }
      if (!inc.sum) {
        toastr['warning']('Введите сумму!');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/reports/updateIncome', {
        action: 'sideServiceIncome',
        income: inc
      });
      if (data.success) {
        this.newIncome = {
          source_id: 0,
          sum: null,
          wallet: null,
        }
        await this.showReport(true);
      } else {
        toastr['warning'](data.message ?? 'Ошибка');
      }
      this.btnLoading = false;
    },
    async removeRecord() {

    },
    async addExpenses() {
      const exp = {...this.newExpenses};
      if (!+exp.card_id) {
        toastr['warning']('Выберите карту!');
        return;
      }
      if (!exp.sum) {
        toastr['warning']('Введите сумму!');
        return;
      }
      if (!exp.comment) {
        toastr['warning']('Введите комментарий!');
        return;
      }
      this.btnLoading = true;
      const {data} = await api.post('/reports/updateExpenses', {
        expenses: [{
          ...exp,
          type_id: 29,
          currency_id: 33,
        }],
        date: this.$refs.expensesDate.date,
      })
      if (data.success) {
        this.newExpenses = {
          card_id: 0,
          sum: null,
          comment: null,
          affect_saldo: 1
        }
        await this.showReport(true);
      }
      this.btnLoading = false;
    },
    async showReport(silent = false) {
      this.loading = !silent;
      const {data} = await api.index('/reports/non-cash?date=' + this.$refs.date.date);
      if (data.success) {
        this.cards = data.cards.reduce((acc, c) => {
          acc[c.id] = c;
          return acc;
        }, {})
        this.withdrawal = data.withdrawal;
        this.expenses = data.expenses;
        this.records = data.records;
      }
      this.loading = false;
    }
  }
}

</script>

<style scoped>
.flex_gap {
  gap: 10px;
}

.form-group {
  margin-bottom: 0;
}
</style>
